import React, { Component } from 'react';
import './footer.scss'
import {  withRouter } from 'react-router-dom'
import { getApiLogoList } from "../../axios/api"

class footer extends Component {

    state = {
        info:{
            sixmoney:{},
            sixmoneys:{},
            sixmoneyn:{},
            sixcar:{},

            address:{},
            dyqrcode:{},
            image:{},
            logo:{},
            mobile:{},
            ontime:{},
            wcontent:{},
            wechatqrcode:{},
            wtitle:{},
        },

        logoList:[],
    }


    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    componentWillMount(){
        getApiLogoList()
        .then( req =>{
            if(req.data.code === 1){
                this.setState({
                    logoList:req.data.data
                })
            }
        }).catch(err =>{
            console.error(err);
        })
    }

    componentDidMount(){

    }


    render() {
        return (
            <div className="footer">
                <div className="f1">
                    <div className='fcen'>
                        <div className='fbox'>
                            <div className='fdiv'>
                                <div className='ftu'>
                                    <img alt="" src="/www/assets/imgs/logo.png" />
                                    <h1>灵氪科技产业服务平台</h1>
                                </div>
                                <h2>
                                    <span onClick={()=>{this.gotoPage('/')}}>首页</span> ｜ 
                                    <span onClick={()=>{this.gotoPage('/industrialMap')}}>产业图谱</span> ｜  
                                    <span onClick={()=>{this.gotoPage('/service')}}>服务大厅</span> ｜ 
                                    <span onClick={()=>{this.gotoPage('/talents')}}>专家人才</span> ｜ 
                                    <span onClick={()=>{this.gotoPage('/skill')}}>科技成果</span> ｜ 
                                    <span onClick={()=>{this.gotoPage('/policy')}}>科创政策</span> ｜ 
                                    <span onClick={()=>{this.gotoPage('/project')}}>项目选址</span> ｜ 
                                    <span onClick={()=>{window.open('https://course.pkusp.com/')}}>培训课程</span> ｜ 
                                    <span onClick={()=>{this.gotoPage('/activity')}}>科创活动</span> ｜ 
                                    <span onClick={()=>{this.gotoPage('/about')}}>关于我们</span>  
                                    {/* <span onClick={()=>{

                                    if(this.props.type === 1){
                                    window.scroll(0, 5000);
                                    }else{
                                    this.gotoPage('/home?end=1')
                                    }

                                    }}>硅巷载体</span> */}
                                </h2>
                            </div>
                            <div className='fimgs'>
                                {
                                    this.state.logoList.map((item,index)=>{
                                        return <div className='fm' key={index} style={{backgroundImage:"url('"+item.logo+"')"}}></div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="f2">
                    <div>
                        <p>Copyright © 2022 灵氪科技产业服务平台｜<span onClick={()=>{window.open('http://beian.miit.gov.cn')}}>粤ICP备2022131206号</span></p>
                    </div>
                    {/* <div>
                        <img alt="" src="/www/assets/imgs/jinghui.png" />
                        <p>北京北大科技园建设开发有限公司</p>
                    </div> */}
                    <div>
                        <p>技术支持：深圳伊灵灵伊科技有限公司</p>
                    </div>
                </div>

                <div className='fbtop' onClick={()=>{window.scroll(0,0)}}>
                    <img alt="" src="/www/assets/imgs/top.png" />
                </div>
            </div>
        );
    }
}

export default withRouter(footer);